export default class CartTimer {

    private startSecondsRemaining: number;
    private startTime: Date;
    private intervalHandle: number;
    constructor() {
        this.startTime = new Date();
        const remainingTime: string = window["cartTimerSeconds"];

        if (remainingTime !== undefined) {
            this.tick = this.tick.bind(this);

            const startingMinutes = +remainingTime.split(':')[0];
            const startingSeconds = +remainingTime.split(':')[1];

            this.startSecondsRemaining = (+startingMinutes * 60) + startingSeconds;

            this.startCountDown();

            this.visibleTabHandler();
        }
    }

    tick() {
        const currentTime = new Date();

        // in seconds
        const elapsedTime = Math.floor((currentTime.getTime() - this.startTime.getTime()) / 1000);

        const secondsRemaining = this.startSecondsRemaining - elapsedTime;

        const min = Math.floor(secondsRemaining / 60);
        const sec = secondsRemaining - (min * 60);

        let newSeconds = sec.toString();
        let newMinutes = min.toString();

        if (sec < 10 && newSeconds.length < 2) {
            newSeconds = "0" + newSeconds;
        }
        if (min < 10 && newMinutes.length < 2) {
            newMinutes = "0" + newMinutes;
        }

        if (secondsRemaining <= 0) {
            clearInterval(this.intervalHandle);
            const cartTimerWrapper = document.getElementById("cart-timer");
            cartTimerWrapper.classList.add('expired');
            window.location.href = "/cart/?error=expired";
            return;
        }

        const minutesSpan = document.getElementById("CartTimerMinutes");
        const secondsSpan = document.getElementById("CartTimerSeconds");

        minutesSpan.innerHTML = newMinutes;
        secondsSpan.innerHTML = newSeconds;
    }

    visibleTabHandler() {
        const self = this;
        document.addEventListener("visibilitychange", function () {

            if (document.visibilityState !== "hidden") {
                self.startCountDown();
            } else {
                clearInterval(self.intervalHandle);
            }
        });
    }

    startCountDown() {
        this.intervalHandle = window.setInterval(this.tick, 1000);
    }
}

(window as any).CartTimer = CartTimer;

if (typeof window !== 'undefined' && window["cartTimerSeconds"]) {
    new CartTimer();
}
